module.exports = __webpack_public_path__ + "static/media/amex-logo.21407e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/amex-logo.png
// module id = 2237
// module chunks = 0